import React, { useState, useEffect } from "react";
import { FacebookOutlined, TwitterOutlined, MailOutlined, InstagramOutlined, PhoneOutlined, HomeOutlined } from "@ant-design/icons";
import Chatbot from "./Chatbot";
import colors from "../../assets/styles/colour";

function Contact() {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("contact-section");
      if (section) {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (sectionTop < windowHeight * 0.8) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const contactContainerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "60px 40px",
    background: "#ffffff",
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0px)" : "translateY(50px)",
    transition: "opacity 1s ease-out, transform 1s ease-out",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    width: "100%",
    margin: "auto",
    overflow: "hidden",
    textAlign: "center"
  };
  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "40px",
    background: "#f4f8fc",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "1800px",
    margin: "auto",
    flexWrap: "wrap",
    gap: "20px",
    };
    
    const leftSectionStyle = {
    flex: "1",
    minWidth: "250px",
    };
    
    const middleSectionStyle = {
    flex: "1.5",
    minWidth: "300px",
    textAlign: "center",
    };
    
    const rightSectionStyle = {
    flex: "1",
    minWidth: "250px",
    };
    
    const formStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    width: "100%",
    };
    
    const inputStyles = {
    width: "90%",
    padding: "10px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    };
    
    const textareaStyles = {
    ...inputStyles,
    height: "120px",
    resize: "none",
    };
    
    const buttonStyles = {
    backgroundColor: colors.button,
    color: colors.textSecondary,
    border: "none",
    padding: "12px 20px",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: "5px",
    transition: "0.3s",
    };
    
    const headingStyle = {
    textAlign: "center",
    fontSize: "22px",
    marginBottom: "15px",
    color: colors.textColor,
    };
    
    const iconContainerStyle = {
    display: "flex",
    gap: "15px",
    fontSize: "24px",
    justifyContent:"center"
    };
    
  

  const iconStyle = {
    fontSize: "30px",
    color: "#ec9949",
    transform: "scale(1)",
    transition: "transform 0.3s ease-in-out, color 0.3s ease-in-out",
  };

  const iconHoverStyle = {
    transform: "scale(1.2)",
    color: "#063970",
  };
  // const inputStyles = {
  //   width: "90%",
  //   maxWidth: "400px",
  //   padding: "12px",
  //   fontSize: "16px",
  //   border: "1px solid #ccc",
  //   borderRadius: "8px",
  //   outline: "none",
  //   transition: "border 0.3s ease",
  //   boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  // };
  
  // const buttonStyles = {
  //   background: "#063970",
  //   color: "#fff",
  //   padding: "12px 20px",
  //   border: "none",
  //   borderRadius: "8px",
  //   cursor: "pointer",
  //   fontSize: "16px",
  //   transition: "background 0.3s ease",
  //   width: "90%",
  //   maxWidth: "400px",
  //   textAlign: "center",
  // };

  return (
    <div style={containerStyle}>
    {/* Left: Contact Info */}
    <div style={leftSectionStyle}>
      <h1 style={{color: colors.textColor}}>Connect with Us</h1>
      <p>
        <MailOutlined /> <strong>Email:</strong> it.bjp.odisha@gmail.com <br />
        <PhoneOutlined /> <strong>Phone:</strong> +91 1234567890 <br />
        <HomeOutlined /> <strong>Address:</strong> Bhubaneswar,Odisha, India
      </p>
      <Chatbot/>
    </div>

    {/* Middle: Contact Form */}
    <div style={middleSectionStyle}>
      <h2 style={headingStyle}>Send Us a Message</h2>
      <form style={formStyle}>
        <input type="text" placeholder="Your Name" required style={inputStyles} />
        <input type="email" placeholder="Your Email" required style={inputStyles} />
        <textarea placeholder="Your Message" rows="4" required style={textareaStyles}></textarea>
        <button type="submit" style={buttonStyles}>Send Message</button>
      </form>
    </div>

    {/* Right: Social Media & Google Map */}
    <div style={rightSectionStyle}>
      <h2 style={headingStyle}>Follow Us</h2>
      <div style={iconContainerStyle}>
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
          <FacebookOutlined style={iconStyle} />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <TwitterOutlined style={iconStyle} />
        </a>
        <a href="mailto:support@example.com">
          <MailOutlined style={iconStyle} />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
          <InstagramOutlined style={iconStyle} />
        </a>
      </div>
     
      
    </div>
    
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62228.51541708747!2d77.5544735!3d12.9715987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670f4f3f5a9%3A0xe18e869c3b0f51bb!2sBengaluru%2C%20Karnataka%2C%20India!5e0!3m2!1sen!2sin!4v1711441234567!5m2!1sen!2sin"
        width="100%"
        height="200"
        style={{ border: "0", marginTop: "20px" }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
  </div>
);
};

// CSS Styles

  

export default Contact;
